document.addEventListener('DOMContentLoaded', function () {
    const mediaQuery = window.matchMedia('(max-width: 699px)');
    const menuHeaders = document.querySelectorAll('.menu-list-footer__item_header');

    function handleAccordion() {
        if (mediaQuery.matches) {
            // Mobile view
            menuHeaders.forEach((header) => {
                header.addEventListener('click', function (e) {
                    e.preventDefault();

                    // Toggle arrow state
                    const arrow = this.querySelector('.menu-list-footer__arrow');
                    arrow.classList.toggle('active');

                    // Find the list that should be toggled
                    const parentItem = this.closest('.menu-list-footer__item');
                    const list = parentItem.querySelector('.menu-list-footer__item-list');
                    parentItem.classList.toggle('active');

                    // Toggle the list visibility
                    if (list.style.height === 'auto' || parseInt(list.style.height) > 0) {
                        list.style.height = '0px';
                    } else {
                        list.style.height = list.scrollHeight + 'px';
                    }
                });
            });
        } else {
            // Desktop view - remove event listeners and reset heights
            menuHeaders.forEach((header) => {
                const parentItem = header.closest('.menu-list-footer__item');
                const list = parentItem.querySelector('.menu-list-footer__item-list');
                if (list) {
                    list.style.height = 'auto';
                }

                const arrow = header.querySelector('.menu-list-footer__arrow');
                if (arrow) {
                    arrow.classList.remove('active');
                    parentItem.classList.remove('active');
                }
            });
        }
    }

    // Run on load
    handleAccordion();

    // Run on window resize
    mediaQuery.addEventListener('change', handleAccordion);
});
